
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useVendorStore from "../../HomePage/useVendorStore";
import { STATUS_BEGIN, STATUS_DONE } from "utils/constants/others";
import { DownloadInvoice } from "../../../../operations/operations";
import { PDFDocument } from "pdf-lib";

export default function useDDPoDetailsLogic() {
  const getPurchaseOrders = useVendorStore((state) => state.getPurchaseOrders);
  const getPurchaseOrderStatus = useVendorStore(
    (state) => state.getPurchaseOrderStatus
  );
  const purchaseOrders = useVendorStore((state) => state.purchaseOrders);
  const getPoGrnMappings = useVendorStore((state) => state.getPoGrnMappings);
  const getPoGrnMappingStatus = useVendorStore(
    (state) => state.getPoGrnMappingStatus
  );
  const [po, setPo] = useState("");
  const [grn, setGrn] = useState("");
  const poGrnList = useVendorStore((state) => state.poGrnList);

  const [items, setItems] = useState("");
  let { source, purchaseOrderId } = useParams();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [tonnage, setTonnage] = useState(0);
  const [popupText, setPopupText] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const sellerOrderDetailsStatus = useVendorStore((state) => state.sellerOrderDetailsStatus);
  const getBuyerOrderPodDetails = useVendorStore((state) => state.getBuyerOrderPodDetails);
  const buyerOrdersLinkedtoPO = useVendorStore((state) => state.buyerOrdersLinkedtoPO);
  const [deliveryInvoices, setDeliveryInvoices] = useState([]);
  const [showInvoiceNumberModal, setShowInvoiceNumberModal] = useState(false);
  const [overriddenInvoiceNumber, setOverriddenInvoiceNumber] = useState("");
  const [totalBuyerOrders, setTotalBuyerOrders] = useState(0);
  const [invoiceGeneratedOrders, setInvoiceGeneratedOrders] = useState(0);

  useEffect(() => {
    if (source === "pod") {
      getPurchaseOrders({
        is_item_required: true,
        purchase_order_id: purchaseOrderId,
      }, true);
      getBuyerOrderPodDetails({
        purchase_order_id: purchaseOrderId,
      });
    } else {
      getPoGrnMappings({
        purchase_order_id: purchaseOrderId,
        is_po_grn_items_required: true,
        get_cn_data: true,
      }, true);
      getPurchaseOrders({
        is_item_required: true,
        purchase_order_id: purchaseOrderId,
        is_delivery_details_required: false,
      }, true);
      getBuyerOrderPodDetails({
        purchase_order_id: purchaseOrderId,
      });
    }
  }, []);

  useEffect(() => {
    if (getPoGrnMappingStatus === STATUS_DONE && poGrnList) {
      setGrn(poGrnList[0]);
    }
  }, [poGrnList]);

  useEffect(() => {
    if (getPurchaseOrderStatus === STATUS_DONE && purchaseOrders) {
      setPo(purchaseOrders[0]);
      if (source !== "pod") {
        setShowLoader(false);
      }
    }
  }, [purchaseOrders]);

  useEffect(() => {
    if (po.purchase_order_items) {
      setItems(po.purchase_order_items);
    }
  }, [po]);

  useEffect(() => {
    if (getPurchaseOrderStatus === STATUS_BEGIN) {
      setShowLoader(true);
    }
  }, [getPurchaseOrderStatus]);

  useEffect(() => {
    switch (getPoGrnMappingStatus) {
      case STATUS_BEGIN:
        setShowLoader(true);
        break;
      case STATUS_DONE:
        setShowLoader(false);
        break;
    }
  }, [getPoGrnMappingStatus]);

  useEffect(() => {
    if (sellerOrderDetailsStatus === STATUS_DONE) {
      setShowLoader(false);
    }
  }, [sellerOrderDetailsStatus]);

  useEffect(() => {
    setShowLoader(false);
    

    let downloadableInvoices = [];
    setTotalBuyerOrders(buyerOrdersLinkedtoPO.length);
    for (let i = 0; i < buyerOrdersLinkedtoPO.length; i++) {
      let isOrderInvoicePresent = false;
      for (let j = 0; j < buyerOrdersLinkedtoPO[i].invoice_details.length; j++) {
        if (buyerOrdersLinkedtoPO[i].invoice_details[j].presigned_url.length > 0) {
          downloadableInvoices.push({
            url: buyerOrdersLinkedtoPO[i].invoice_details[j].presigned_url,
            fileName: "Invoice_" + buyerOrdersLinkedtoPO[i].buyer_order_number + "_" + (j + 1)
          });
          isOrderInvoicePresent = true;
        }
      }

      if (buyerOrdersLinkedtoPO[i].delivery_info_note.length > 0) {
        downloadableInvoices.push({
          url: buyerOrdersLinkedtoPO[i].delivery_info_note,
          fileName: "Delivery_info_note_" + buyerOrdersLinkedtoPO[i].buyer_order_number
        });
        isOrderInvoicePresent = true;
      }
      if (buyerOrdersLinkedtoPO[i].e_way_bill.length > 0) {
        downloadableInvoices.push({
          url: buyerOrdersLinkedtoPO[i].e_way_bill,
          fileName: "E_way_bill_" + buyerOrdersLinkedtoPO[i].buyer_order_number
        });
        isOrderInvoicePresent = true;
      }

      if (isOrderInvoicePresent) {
        setInvoiceGeneratedOrders(prev => prev + 1);
      }
    }
    setDeliveryInvoices(downloadableInvoices);
  }, [buyerOrdersLinkedtoPO]);

  useEffect(() => {
    calculateTonnage();
  }, [items]);

  const calculateTonnage = () => {
    let total = 0;
    for (const item of items) {
      total = total + item.quantity_ordered * item.weight_per_packet;
    }
    setTonnage(total);
  };

  const goToDDList = () => {
    navigate(`/ddPo/all`);
  };

  const navigateToInvoiceForm = () => {
    navigate(`/ddPo/invoice/${po.id}`);
  };

  const navigateToBuyerOrdersList = () => {
    if (po?.is_bor_distribution_enabled) {
      setPopupText("Orders will be marked as delivered automatically");
      togglePopupModel();
    } else {
      navigate(`/ddPo/${purchaseOrderId}/buyer_orders`);
    }
  };

  const handleGenerateEwb = () => {
    let isEwbGenerated = (buyerOrdersLinkedtoPO && buyerOrdersLinkedtoPO.length > 0);
    if (isEwbGenerated) {
      for (let i = 0; i < buyerOrdersLinkedtoPO.length; i++) {
        if (
          buyerOrdersLinkedtoPO[i].e_way_bill_status !== "SUCCEEDED" &&
          buyerOrdersLinkedtoPO[i].e_way_bill_status !== "FAILED" &&
          buyerOrdersLinkedtoPO[i].e_way_bill_status !== "PENDING"
        ) {
          isEwbGenerated = false;
          break;
        }
      }
    }

    if (isEwbGenerated) {
      setPopupText("E-Way bill is already generated. Please download it from the 'Download delivery documents'");
      togglePopupModel();
    } else {
      navigate(`/ddPo/generateEwb/${purchaseOrderId}`);
    }
  };

  const togglePopupModel = () => {
    setShowPopup(!showPopup);
  };

  const downloadDeliveryInvoices = async () => {
    if (deliveryInvoices.length > 0) {
      try {
        const urls = deliveryInvoices.map(invoice => invoice.url);

        const pdfDocs = await Promise.all(
          urls.map(async (url) => {
            const res = await fetch(url);
            const buffer = await res.arrayBuffer();
            return PDFDocument.load(buffer);
          })
        );

        const mergedPdf = await PDFDocument.create();

        for (const pdfDoc of pdfDocs) {
          const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
          pages.forEach((page) => mergedPdf.addPage(page));
        }

        const mergedBytes = await mergedPdf.save();

        const blob = new Blob([mergedBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Delivery_Documents_PO_${po.purchase_order_number}.pdf`;
        link.click();

        URL.revokeObjectURL(link.href);

        if (invoiceGeneratedOrders < totalBuyerOrders) {
          setPopupText(`${invoiceGeneratedOrders}/${totalBuyerOrders} invoices generated. Please download pending invoices in some time.`);
          togglePopupModel();
        }
      } catch (error) {
        console.error('Error merging PDFs:', error);
        setPopupText("Error downloading documents. Please try again.");
        togglePopupModel();
      }
    } else {
      setPopupText("Invoice and delivery challan is not generated yet");
      togglePopupModel();
    }
  };

  const clickInsertInvoiceNumber = () => {
    setShowInvoiceNumberModal(true);
  };

  const generateInvoiceCTA = () => {
    if ((overriddenInvoiceNumber?.length == 0) && showInvoiceNumberModal) {
      setPopupText("Please enter invoice number");
      togglePopupModel();
      return;
    }
    navigate(`/grn/invoice/dd/${purchaseOrderId}/${grn.id}?invoice_number=${overriddenInvoiceNumber}`);
  };

  function downloadPdfFromS3(s3Url, filename) {
    DownloadInvoice(s3Url, filename);
    if (window && window.downloadFileMessageHandler) {
      window.downloadFileMessageHandler.postMessage(s3Url);
    }
  }

  const handleInvoiceNumberChange = (invoiceNumber) => {
    setOverriddenInvoiceNumber(invoiceNumber);
  };

  function shouldShowEwbButton() {
    return po.order_bill_image?.length != 0;
  }

  /**
   * Returns { label, onClick } for the primary action bar CTA.
   * Used by both DDPoDetailsDesktop and DDPoDetailsMobile so the
   * logic lives in one place.
   */
  function getActionBarCTA() {
    if (
      grn?.seller_status != "APPROVED" &&
      grn?.is_invoice_generation_allowed_for_seller_hub &&
      po.seller_info?.is_supplier_bill_number_override_enabled
    ) {
      return { label: "Click to Generate Invoice", onClick: clickInsertInvoiceNumber };
    }
    if (
      grn?.seller_status != "APPROVED" &&
      grn?.is_invoice_generation_allowed_for_seller_hub &&
      grn?.supplier_bill_number?.length > 0
    ) {
      return { label: "Click to Generate Invoice", onClick: generateInvoiceCTA };
    }
    if (po.order_bill_image?.length == 0) {
      return { label: "Upload invoice", onClick: navigateToInvoiceForm };
    }
    return { label: "Click to mark delivered", onClick: navigateToBuyerOrdersList };
  }

  return {
    po,
    grn,
    items,
    source,
    purchaseOrderId,
    navigate,
    showLoader,
    tonnage,
    popupText,
    showPopup,
    buyerOrdersLinkedtoPO,
    deliveryInvoices,
    showInvoiceNumberModal,
    setShowInvoiceNumberModal,
    overriddenInvoiceNumber,
    totalBuyerOrders,
    invoiceGeneratedOrders,
    navigateToInvoiceForm,
    navigateToBuyerOrdersList,
    handleGenerateEwb,
    togglePopupModel,
    downloadDeliveryInvoices,
    clickInsertInvoiceNumber,
    generateInvoiceCTA,
    downloadPdfFromS3,
    handleInvoiceNumberChange,
    shouldShowEwbButton,
    getActionBarCTA,
    goToDDList,
  };
}
